// extracted by mini-css-extract-plugin
export default {"emptyCatalogRoot":"emptyCatalogRoot__X7oKy","emptyCatalogTitle":"emptyCatalogTitle__Tu1TY","tipsList":"tipsList__X6Irv","clearCategoriesButton":"clearCategoriesButton__QLMMB"};